:host {
    --wcs-hint-font-size-default: var(--wcs-semantic-font-size-caption-2);
    --wcs-hint-font-size-small: var(--wcs-semantic-font-size-caption-3);
    --wcs-hint-font-weight: var(--wcs-semantic-font-weight-book);
    --wcs-hint-color: var(--wcs-semantic-color-text-secondary);

    font-size: var(--wcs-hint-font-size-default);
    font-weight: var(--wcs-hint-font-weight);
    color: var(--wcs-hint-color);
}

:host([small]) {
    font-size: var(--wcs-hint-font-size-small);
    font-weight: var(--wcs-hint-font-weight);
}
